import { ZoneId } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
export function createZoneIdFromInternals(value) {
    // The only zone that does not have an _id is the system default
    const zoneId = value._id ? ZoneId.of(value._id) : ZoneId.systemDefault();
    return zoneId;
}
/**
 * Serializer for ZoneId
 */
/*
  Differently from other js-joda serialized values, ZoneId has nested objects with their own prototypes.
  Hence, a mere Object.assign doesn't work here (Object.assign does a shallow copy only).
  As a simplistic workaround, we rely on knowing js-joda's ZoneId's internals here to map private fields to their
  prototypes.
 */
export const zoneIdSerializer = CreateSerializer(serializeZoneId, deserializeZoneId);
function serializeZoneId(value) {
    return createZoneIdFromInternals(value).toString();
}
function deserializeZoneId(value) {
    try {
        return ZoneId.of(value);
    }
    catch (err) {
        // some consumers (e.g. web) don't include @js-joda/timezone and cannot deserialize ZoneId
        return value;
    }
}
